import axios from 'axios'

export default {
  submitFeed: params => axios.post(`https://open.xueersi.com/StuFeedback/save`, params)
}



// WEBPACK FOOTER //
// ./src/networks/api/Feedback/index.js